import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input, EventEmitter, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import {  ShortNamePipe } from '@fitness-force/pipes/short-name'
import { AvatarModule } from 'primeng/avatar';
import { PopoverModule } from 'primeng/popover';
import { StyleClassModule } from 'primeng/styleclass';
import { BehaviorSubject } from 'rxjs';
import { ClientService } from '@fitness-force/api';
import { TransferType } from '@fitness-force/enum';
import { Store } from '@ngrx/store';
import { TENANTSINTERFACE, TENANT_MODEL } from '@fitness-force/models';
import { TENANTS_INFO } from 'apps/ff-frontend/src/app/state/app.state';

@Component({
  selector: 'transferred-to',
  templateUrl: './transferred-to.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    PopoverModule,
    AvatarModule,
    StyleClassModule,
    ShortNamePipe,
    RouterModule
  ]
})
export class TransferredToComponent implements OnInit {
  @Input() columnData = new BehaviorSubject(null);
  @Output() onAction = new EventEmitter(); // {type:actionName,columnData }
  constructor(private router: Router,private store: Store, private clientService: ClientService) { }
  colData=new BehaviorSubject<any>(null);
  showIcon=true;
  locationTransfer=true;
  ngOnInit(): void {
    this.columnData.subscribe({
      next:(col:any)=>{
        if(TransferType[TransferType.LocationToLocation]===col?.transfer_type){
          this.locationTransfer=false;
          this.getTenantData(col?.transfer_to_tenant_id)
        }else {
          this.colData.next(col?.transfer_to_client)
          this.showIcon=false;
        }
      }
    })
  }

  getTenantData(tenantId:number){
    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      this.colData.next(tenant.all_tenant.find((currentTenant:TENANT_MODEL)=>(currentTenant.id===tenantId)));
    })
  }

  // gotoClient(id: any) {
  //   const url = this.router.serializeUrl(
  //     this.router.createUrlTree(['/client/profile/', id])
  //   );
  //   window.open(url, '_blank');
  // }


  getClientType(row: any): string {
    switch (row?.client_status) {
      case "Client":
        return "Member";
      default:
        return ""
    }
  }

  clientStatus(client: any): string {
    if (client && client.client_status)
      return this.clientService.getClientStatusHtml(client.client_status.toString());
    else
      return '';
  }

  executeAction(action: string, columnData: any) {
    this.onAction.emit({ action, columnData });
  }
}
